"use client";
import { useMemo } from "react";
import { useQuery } from "@stadium/services/react-query";
import { fetchConfig } from "./fetch-config";

const useFetchConfig = ({ configPayload, programIdentifier, enabled = true }) => {
  const { data, isLoading, refetch } = useQuery(
    ["fetch-config", configPayload],
    () => fetchConfig(configPayload),
    {
      refetchOnWindowFocus: false,
      enabled: enabled,
    },
  );

  const configData = useMemo(
    () => ({
      ...data,
      isFetching: isLoading,
      activeProgramDetail: data?.activeProgramDetails?.[programIdentifier],
    }),
    [data],
  );

  return { configData, isLoading, refetch };
};

export default useFetchConfig;
